import { API } from 'aws-amplify';
import {
  listExclusions
} from '../graphql/queries';
import {
  createExclusion,
  deleteExclusion,
  updateExclusion
} from '../graphql/mutations';
import { APP_AUTH_MODE } from '../constants/app';

const _listExclusionsSortByDate = async (governmentId, nextToken, sortDirection='DESC') => {
    try {
        const res = await API.graphql({
        query: listExclusions,
        variables: {
            governmentId: governmentId,
            sortDirection,
            nextToken
        },
        authMode: APP_AUTH_MODE
        })

        if (res.data['listExclusions']) {
            return {
                success: true,
                data: res.data['listExclusions'].items,
                nextToken: res.data['listExclusions'].nextToken
            }
        }
        return {
            success: false,
            error: res.data.errors
        }
    }
    catch (e) {
        return {
            success: false,
            error: e
        }
    }
}

const _createExclusion = async (input) => {
    try {
        console.log("createExclusion", input)
        const res = await API.graphql({
            query: createExclusion,
            variables: {
                input: {
                    governmentId: input.governmentId,
                    url: input.url
                }
            },
            authMode: APP_AUTH_MODE
        })
        if (res.data['createExclusion']) {
            return {
                success: true,
                data: res.data['createExclusion']
            }
        }
        return {
            success: false,
            error: res.data.errors
        }
    }
    catch (e) {
        return {
            success: false,
            error: e
        }
    }
}

const _deleteExclusion = async (input) => {
    try {
        const res = await API.graphql({
            query: deleteExclusion,
            variables: {
                input: {
                    governmentId: input.governmentId,
                    createdAt: input.createdAt
                }
            },
            authMode: APP_AUTH_MODE
        })
        if (res.data['deleteExclusion']) {
            return {
                success: true,
                data: res.data['deleteExclusion']
            }
        }
        return {    
            success: false,
            error: res.data.errors
        }
    }
    catch (e) {
        return {
            success: false,
            error: e
        }
    }
}

const _updateExclusion = async (input) => {
    try {
        const res = await API.graphql({
            query: updateExclusion,
            variables: {
                input: {
                    id: input.id,
                    url: input.url,
                    governmentId: input.governmentId,
                    updatedAt: input.updatedAt,
                    createdAt: input.createdAt
                }
            },
            authMode: APP_AUTH_MODE
        })
        if (res.data['updateExclusion']) {
            return {
                success: true,
                data: res.data['updateExclusion']
            }
        }
        return {
            success: false,
            error: res.data.errors
        }
    }
    catch (e) {
        return {
            success: false,
            error: e
        }
    }
}

const listExclusionsSortByDate = async (governmentId, nextToken, sortDirection='DESC') => {
    return await _listExclusionsSortByDate(governmentId, nextToken, sortDirection);
}

const adminCreateExclusion = async (input) => {
    return await _createExclusion(input);
}

const adminUpdateExclusion = async (input) => {
    return await _updateExclusion(input);
}

const adminDeleteExclusion = async (input) => {
    return await _deleteExclusion(input);
}

export {
    listExclusionsSortByDate,
    adminCreateExclusion,
    adminUpdateExclusion,
    adminDeleteExclusion
}
